import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import { MapContainer } from "react-leaflet";
import { useMaps } from "../_contexts";

import { StaticMap } from "./";

export function MapViewport() {
  const { currentMap, coords, setCoords } = useMaps();
  const map = { ...currentMap };
  const [zoomRange, setZoomRange] = useState({ min: -5, max: 5 });
  // console.log('Map Viewport Created');
  // const { options } = map;
  const [leafletMap, setLeafletMap] = useState(null);
  const [isMoving, setIsMoving] = useState(false);
  const { items: maps } = useSelector((state) => state.maps);

  const handleCreate = (map) => {
    setLeafletMap(map);
  };

  const center = useMemo(() => {
    console.log("Calculating image dimensions");
    return [
      currentMap.image?.properties.height / 2 || 0,
      currentMap.image?.properties.width / 2 || 0,
    ];
  }, [currentMap, maps]);

  useEffect(() => {
    if (!coords) {
      setCoords({
        x: center[1],
        y: center[0],
        z: map.options.zoomDefault,
      });
    }
    // console.log("ZOOM Range: ", zoomRange);
    // if(currentMap.options.zoomMin !== undefined || currentMap.options.zoomMax !== undefined)
    // setZoomRange({
    //   min: currentMap.options?.zoomMin || -5,
    //   max: currentMap?.options?.zoomMax || 5,
    // });
    if (leafletMap) {
      leafletMap.setMinZoom(
        Math.min(currentMap.options.zoomMin, currentMap.options.zoomMax)
      );
      leafletMap.setMaxZoom(
        Math.max(currentMap.options.zoomMax, currentMap.options.zoomMin)
      );
    }

    // leafletMap.setC;
    // console.log("New ZOOM: ", currentMap.options);
  }, [leafletMap, currentMap, center, map]);

  const MapItem = React.useMemo(() => {
    // console.log("--------Receiving update");
    return <StaticMap map={currentMap} isMoving={isMoving} />;
  }, [currentMap, leafletMap, center, map]);

  return (
    <div className="chronos-map-wrapper">
      <MapContainer
        className="chronos-map-viewport"
        attributionControl={false}
        zoomControl={false}
        crs={L.CRS.Simple}
        center={center}
        whenCreated={handleCreate}
        minZoom={zoomRange.min}
        maxZoom={zoomRange.max}
        zoom={coords.z}
        zoomSnap={0.25}
        tap={false}
      >
        {MapItem}
      </MapContainer>
    </div>
  );
}
